import React from 'react';

export default class Modal extends React.Component {
  listenKeyboard(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      this.props.onClose();
    }
  }

  componentDidMount() {
    if (this.props.onClose) {
      window.addEventListener('keydown', this.listenKeyboard.bind(this), true);
    }
  }

  componentWillUnmount() {
    if (this.props.onClose) {
      window.removeEventListener('keydown', this.listenKeyboard.bind(this), true);
    }
  }

  onOverlayClick() {
    this.props.onClose();
  }

  render() {
    const cssClass = `modal-dialog-div ${this.props.className}` || 'modal-dialog-div';

    if (this.props.show) {
      return (
        <div>
          <div className="modal-overlay-div" />
          <div className="modal-content-div" onClick={this.onOverlayClick.bind(this)}>
            <div className={cssClass}>{this.props.children}</div>
          </div>
        </div>
      );
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/modal.js